import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
// Import ikon mata dari heroicons (atau gunakan SVG di bawah jika tidak pakai library ikon)
import { HiEye, HiEyeOff } from 'react-icons/hi'; 

const ChangePassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitting new password:", newPassword, "Confirm password:", confirmPassword);

    if (newPassword !== confirmPassword) return toast.error('Confirm password does not match');
    if (newPassword.length < 6) return toast.error('Minimum 6 characters');

    try {
      setLoading(true);
        const token = localStorage.getItem('token') ||
                      JSON.parse(localStorage.getItem('admin'))?.token ||
                      JSON.parse(localStorage.getItem('userInfo'))?.token;
        console.log("Retrieved token:", token);

      if (!token) {
        return toast.error('User not authenticated');
        setLoading(false);
        return;
      }
          
      const config = { 
        headers: { 
            'content-type': 'application/json',
            Authorization: `Bearer ${token}`
         } 
        };

      const { data } = await axios.put(`/api/users/profile`, { password: newPassword }, config);

      toast.success('Password updated successfully');
        setNewPassword('');
        setConfirmPassword('');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update password');
    } finally {
        setLoading(false);
    }
  }

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-xl shadow-md border border-gray-100 font-sans">
      <div className="flex items-center mb-6">
        <div className="p-2 bg-blue-50 rounded-lg mr-4">
          <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
          </svg>
        </div>
        <h2 className="text-xl font-bold text-gray-800">Change Password</h2>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5">
        {/* Input Password Baru */}
        <div className="relative">
          <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
          <div className="relative">
            <input
              type={showNewPassword ? "text" : "password"}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none pr-10"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
              onClick={() => setShowNewPassword(!showNewPassword)}
            >
              {showNewPassword ? <HiEyeOff size={20} /> : <HiEye size={20} />}
            </button>
          </div>
        </div>

        {/* Konfirmasi Password Baru */}
        <div className="relative">
          <label className="block text-sm font-medium text-gray-700 mb-1">Confirm New Password</label>
          <div className="relative">
            <input
              type={showConfirmPassword ? "text" : "password"}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none pr-10"
              placeholder="Re-enter new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? <HiEyeOff size={20} /> : <HiEye size={20} />}
            </button>
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          className={`w-full py-3 px-4 rounded-lg text-white font-semibold transition-all ${
            loading ? 'bg-blue-300' : 'bg-blue-600 hover:bg-blue-700 active:scale-95'
          }`}
        >
          {loading ? 'Proses...' : 'Save New Password'}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;